let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1R8yl")).then(() => parcelRequire('ahwW5'));